export enum OrderType {
  Sale = 'sale',
  SaleOrder = 'sale-order',
  SaleRefund = 'sale-refund',
}
